import { getCardFilename } from './utils'

// The card is sized in em, so exporting at a fixed width and font size keeps
// the PNG identical no matter how small the viewport was.
const EXPORT_WIDTH = 480
const EXPORT_FONT_SIZE = 16

// The "Verified" stamp describes a moment on screen; a saved image would keep
// claiming it long after, so it never goes into the PNG.
const VERIFIED_SELECTOR = '[data-card-verified]'

const prepareClone = (_clonedDocument, clonedCard) => {
  clonedCard.style.width = `${EXPORT_WIDTH}px`
  clonedCard.style.maxWidth = `${EXPORT_WIDTH}px`
  clonedCard.style.fontSize = `${EXPORT_FONT_SIZE}px`
  clonedCard.style.overflow = 'hidden'
  clonedCard.style.animation = 'none'
  clonedCard.querySelectorAll(VERIFIED_SELECTOR).forEach(node => node.remove())
  clonedCard.querySelectorAll('*').forEach(node => {
    node.style.animation = 'none'
  })
}

export const saveCardImage = async (element, card) => {
  if (document.fonts?.ready) await document.fonts.ready
  const { default: html2canvas } = await import('html2canvas')
  const canvas = await html2canvas(element, {
    scale: 3,
    backgroundColor: null,
    logging: false,
    onclone: prepareClone,
  })
  const link = document.createElement('a')
  link.download = `${getCardFilename(card)}.png`
  link.href = canvas.toDataURL('image/png')
  link.click()
}
